<template>
  <div class="live-assistant-buttons">
    <div class="button-group">
      <button
        class="function-btn"
        :disabled="disabled"
        @click="handleFunction2"
      >
        <img
          src="@/assets/image/aigc/aiagent/icn_fenxi.png"
          alt="查询"
          class="btn-icon"
        />
        直播间数据
      </button>
      <button
        class="function-btn"
        :disabled="disabled"
        @click="handleFunction3"
      >
        <img
          src="@/assets/image/aigc/aiagent/icn_ppt.png"
          alt="分析"
          class="btn-icon"
        />
        到课率
      </button>
      <!-- <button
        class="function-btn"
        :disabled="disabled"
        @click="handleFunction4"
      >
        <img src="@/assets/image/aigc/aiagent/icn_chaxun.png" alt="看板" class="btn-icon" />
        私域看板数据
      </button> -->
      <button
        class="function-btn"
        :disabled="disabled"
        @click="handleFunction5"
      >
        <img
          src="@/assets/image/aigc/aiagent/icn_money.png"
          alt="营收"
          class="btn-icon"
        />
        IP班期营收表
      </button>
      <!-- <button
        class="function-btn"
        :disabled="disabled"
        @click="handleFunction1"
      >
        <img src="@/assets/image/aigc/aiagent/icn_download.png" alt="导出" class="btn-icon" />
        导出实际看播数据
      </button> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'LiveAssistantButtons',
  inject: [
    'getTypeAIList',
    'setChatMessage',
    'getDisabledInput',
    'setDisabledInput'
  ],
  computed: {
    // 判断是否为直播小助手
    isLiveAssistant() {
      const currentAssistant = this.getTypeAIList?.find(item => item.checked)
      return (
        currentAssistant &&
        (currentAssistant.title === '直播小助手' ||
          currentAssistant.name === '直播小助手')
      )
    },
    disabled() {
      return this.getDisabledInput()
    }
  },
  methods: {
    handleFunction1() {
      console.log('导出看播数据被点击')
      this.$emit('function-click', '导出看播数据')
      this.setDisabledInput && this.setDisabledInput(false)
      // 设置提示语到输入框，支持用户修改直播间ID
      this.$store.dispatch(
        'ai/setChatValue',
        '导出 【直播间ID:  】的实际看播用户数据'
      )
    },
    handleFunction2() {
      console.log('查询直播间数据被点击')
      this.$emit('function-click', '查询直播间数据')
      this.setDisabledInput && this.setDisabledInput(false)
      // 设置提示语到输入框，支持用户修改直播间ID
      this.$store.dispatch(
        'ai/setChatValue',
        '查询直播列表【开播时间:  】的直播间数据'
      )
    },
    handleFunction3() {
      console.log('查询到课率被点击')
      this.$emit('function-click', '查询到课率')
      this.setDisabledInput && this.setDisabledInput(false)
      // 设置提示语到输入框，支持用户修改参数
      this.$store.dispatch(
        'ai/setChatValue',
        '查看【线索分配时间:  】、【任务名称:  】、【直播间ID:  】的到课率'
      )
    },
    handleFunction4() {
      console.log('查询私域看板数据被点击')
      this.$emit('function-click', '查询私域看板数据')
      this.setDisabledInput && this.setDisabledInput(false)
      // 设置提示语到输入框，支持用户修改参数
      this.$store.dispatch(
        'ai/setChatValue',
        '帮我查询【任务名称:  】、【线索分配日期:  】私域看板数据'
      )
    },
    handleFunction5() {
      console.log('查询IP班期营收表被点击')
      this.$emit('function-click', '查询IP班期营收表')
      this.setDisabledInput && this.setDisabledInput(false)
      // 设置提示语到输入框，支持用户修改参数
      this.$store.dispatch(
        'ai/setChatValue',
        '帮我查询【跟进人部门： 】，【任务： 】的IP班期营收表'
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.live-assistant-buttons {
  margin-top: 12px;
  padding: 0 16px;

  .button-group {
    margin-top: -10px;
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: space-between;

    .function-btn {
      flex: 1;
      height: 30px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      border-radius: 20px;
      font-size: 12px;
      color: #333333;
      cursor: pointer;
      transition: all 0.2s ease;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 15px;
      white-space: nowrap;
      gap: 4px;
      box-shadow: none;

      &:hover:not(:disabled) {
        background: #f5f5f5;
        border-color: #bfbfbf;
        color: #333333;
        box-shadow: none;
        transform: none;
      }

      &:active:not(:disabled) {
        background: #e6e6e6;
        transform: none;
        box-shadow: none;
      }

      &:disabled {
        background: #f9f9f9;
        border-color: #d9d9d9;
        color: #999999;
        cursor: not-allowed;
        box-shadow: none;
        transform: none;
      }

      .btn-icon {
        width: 14px;
        height: 14px;
        object-fit: contain;
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .live-assistant-buttons {
    .button-group {
      .function-btn {
        font-size: 11px;
        height: 32px;
        min-width: 100px;
        padding: 0 8px;
        gap: 3px;

        .btn-icon {
          width: 12px;
          height: 12px;
        }
      }
    }
  }
}

@media (max-width: 400px) {
  .live-assistant-buttons {
    .button-group {
      .function-btn {
        font-size: 10px;
        height: 28px;
        min-width: 80px;
        padding: 0 6px;
        gap: 2px;

        .btn-icon {
          width: 10px;
          height: 10px;
        }
      }
    }
  }
}
</style>
